import type { JSX, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { FEATURE_FLAGS, flagEnabled, useAuth } from "../../hooks/useAuth";

// The Usage page is behind tool_usage_dashboard; direct navigation while it is
// off bounces to the overview.
export const ToolUsageGate = ({ children }: { children: ReactNode }): JSX.Element => {
  const { user } = useAuth();
  if (flagEnabled(user?.features, FEATURE_FLAGS.toolUsageDashboard)) return <>{children}</>;
  return <Navigate to="/dashboard/overview" replace />;
};
